import { Node } from 'tiptap'
import { insertText } from 'tiptap-commands'

export default class Insert extends Node {
  get name() {
    return 'insert'
  }

  get schema() {
    return {
      attrs: {},
      group: 'inline',
      inline: true,
      selectable: false,
      atom: true
    }
  }

  commands() {
    return () => insertText(':')
  }
}
